import { DependentEntityInfo } from "@common/types";
import { CriteriaHierarchyDependenciesReadModel } from "@Criteria/Hierarchies/Domain/readmodels";

export class EvalModelDeleterViewModel
{
    opened: boolean = false;
    initialized: boolean = false;

    id: number | null = null;
    goalName: string | null = null;
    hasDependants: boolean | null = null;
    dependenciesCount: number | null = null;
    weightedScores: DependentEntityInfo[] = []; 

    show(id: number, goalName: string)
    {
        this.initialized = false;
        this.id = id;
        this.goalName = goalName;
        this.hasDependants = null;
        this.dependenciesCount = null;
        this.weightedScores = [];

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.initialized = false;
        this.id = null;
        this.goalName = null;
        this.hasDependants = null;
        this.dependenciesCount = null;
        this.weightedScores = [];
    }

    setData(deps: CriteriaHierarchyDependenciesReadModel)
    {
        this.hasDependants = deps.HasDependants;
        this.dependenciesCount = deps.DependenciesCount;
        this.weightedScores = deps.WeightedScores;

        this.initialized = true;
    }
}